module.exports = __webpack_public_path__ + "media/images/emblems/Wittnau-blason-c13abf9dbfa25b15d2448a3ff77bbfe5.png";